import managementStoreCore from "@shared/createManagementStoreCore.cjs";

const mutations = {
  ...managementStoreCore.createManagementMutations({ storage: localStorage }),
  LOGOUT(state) {
    state.isLogin = false;
    state._id = null;
    state.email = "";
    state.providerId = null;
    state.providerName = "";
    state.username = "";
    state.mobileNo = "";
    state.selectedProviderChatId = null;
    localStorage.removeItem("accesstoken");
  },
  SET_USER_INFO(state, data) {
    if ((data._id && data._id !== state._id) || (data.providerId && data.providerId !== state.providerId)) state.selectedProviderChatId = null;
    if (data._id) state._id = data._id;
    if (data.email) state.email = data.email;
    if (data.providerId) state.providerId = data.providerId;
    if (data.providerName) state.providerName = data.providerName;
    if (data.username) state.username = data.username;
    if (data.mobileNo) state.mobileNo = data.mobileNo;
  },
  SET_SELECTED_PROVIDER_CHAT(state, id) {
    state.selectedProviderChatId = id || null;
  },
  SET_DASHBOARD_COUNTS(state, data) {
    if (data.todayScheduleCount !== undefined)
      state.todayScheduleCount = data.todayScheduleCount;
    if (data.pendingEstimateCount !== undefined)
      state.pendingEstimateCount = data.pendingEstimateCount;
    if (data.recentReviewCount !== undefined)
      state.recentReviewCount = data.recentReviewCount;
    if (data.unreadNotificationCount !== undefined)
      state.unreadNotificationCount = data.unreadNotificationCount;
  },
};
export default mutations;
